import {
  PowerSyncDatabase,
  WASQLiteOpenFactory,
  WASQLiteVFS,
  type AbstractPowerSyncDatabase,
} from '@powersync/web';
import { AppSchema } from './schema';

let databasePromise: Promise<PowerSyncDatabase> | null = null;

function supportsOpfs(): boolean {
  return typeof navigator !== 'undefined' && Boolean(navigator.storage?.getDirectory);
}

async function openDatabase(): Promise<PowerSyncDatabase> {
  const enableMultiTabs = typeof SharedWorker !== 'undefined';
  const primary = supportsOpfs()
    ? new PowerSyncDatabase({
        schema: AppSchema,
        database: new WASQLiteOpenFactory({
          dbFilename: 'safe-wallet-v1.db',
          vfs: WASQLiteVFS.OPFSCoopSyncVFS,
          flags: { enableMultiTabs },
        }),
        flags: { enableMultiTabs },
      })
    : new PowerSyncDatabase({
        schema: AppSchema,
        database: { dbFilename: 'safe-wallet-v1.db' },
        flags: { enableMultiTabs },
      });

  try {
    await primary.init();
    return primary;
  } catch (error) {
    console.warn('OPFS database initialization failed; using IndexedDB-backed SQLite.', error);
    await primary.close().catch(() => undefined);
    const fallback = new PowerSyncDatabase({
      schema: AppSchema,
      database: { dbFilename: 'safe-wallet-v1-fallback.db' },
      flags: { enableMultiTabs },
    });
    await fallback.init();
    return fallback;
  }
}

export function getDatabase(): Promise<PowerSyncDatabase> {
  databasePromise ??= openDatabase();
  return databasePromise;
}

export type SafeWalletDatabase = AbstractPowerSyncDatabase;
